import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { WhatsAppFloat } from "@/components/site/WhatsAppFloat";
import { QuoteDialog } from "@/components/site/QuoteDialog";
import { FinalCTA } from "@/components/site/FinalCTA";

export default function Placeholder({ title, subtitle }) {
  const [quoteOpen, setQuoteOpen] = useState(false);

  useEffect(() => {
    document.title = `${title} | Bloc & Brush`;
    window.scrollTo(0, 0);
  }, [title]);

  return (
    <div className="bg-white">
      <Navbar onQuoteClick={() => setQuoteOpen(true)} />

      <section className="min-h-[90vh] flex items-center bg-white pt-32">
        <div className="container mx-auto px-6 lg:px-12 max-w-7xl">
          <div className="max-w-3xl">
            <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-[#707070]">
              <Sparkles size={14} className="text-[#13294B]" />
              Coming Soon
            </span>
            <h1 className="font-display mt-6 text-5xl md:text-6xl lg:text-[78px] font-extrabold leading-[0.98] tracking-tight text-[#1C1C1C]">
              {title}
            </h1>
            <p className="mt-6 text-[18px] leading-[1.75] text-[#1C1C1C]/70 max-w-2xl">
              {subtitle ||
                "This page is being crafted with the same attention to detail as every Bloc & Brush project. In the meantime, request a quote or speak directly with our team."}
            </p>
            <div className="mt-10 flex flex-col sm:flex-row gap-3 sm:gap-4">
              <button
                onClick={() => setQuoteOpen(true)}
                data-testid="placeholder-quote-btn"
                className="inline-flex items-center justify-center gap-2 bg-[#13294B] hover:bg-[#0E1F3A] text-white rounded-full px-7 py-4 text-[15px] font-medium transition"
              >
                Get Free Quote <ArrowRight size={16} />
              </button>
              <Link
                to="/"
                className="inline-flex items-center justify-center gap-2 border border-[#13294B]/20 text-[#13294B] hover:bg-[#13294B] hover:text-white rounded-full px-7 py-4 text-[15px] font-medium transition"
              >
                Back to Home
              </Link>
            </div>
          </div>
        </div>
      </section>

      <FinalCTA onQuoteClick={() => setQuoteOpen(true)} />
      <Footer onQuoteClick={() => setQuoteOpen(true)} />
      <WhatsAppFloat />
      <QuoteDialog open={quoteOpen} onOpenChange={setQuoteOpen} />
    </div>
  );
}
